<div class="w-full bg-white">
  <div class="mx-[15%] py-10">
    <div class="shrink-0 justify-between flex">
      <img
        src="images/logo.svg"
        alt="Seiza Logo"
        class="w-36 h-auto cursor-pointer"
        (click)="gotoHome()"
      />

      @if (!userIsAnonymous()) {
        <div class="flex gap-5">
          <app-button
            type="button"
            variant="tertiary"
            text="Cerrar sesión"
            (click)="logout()"
          ></app-button>
          <div class="items-center flex gap-5">
            <img src="icons/avatar_icon.svg" alt="Avatar" />
            <p class="text-th-black text-[16px] font-normal">Hola, {{ userDisplayName() }}</p>
          </div>
          <div class="items-center flex">
            <img
              src="icons/flag_idioma_esp.svg"
              alt="Notificaciones"
              class="w-6 h-6 cursor-pointer"
            />
          </div>
        </div>
      }
    </div>
  </div>
</div>
